export var iconDefaultStyleSheetGetter = _ref => {
  var {
    colorToken = 'icon/color',
    colorTokenArgs,
    designContext
  } = _ref;
  return {
    pathStyle: {
      fill: designContext.get(colorToken, colorTokenArgs).toString(),
      style: {
        transition: 'fill .2s ease'
      }
    }
  };
};
//# sourceMappingURL=icon.js.map